import { useAppContext } from "@/context/AppContext";
import { customSanitize } from "@/utils/customSanitize";
import React from "react";
import styles from "./FormModal.module.scss";
import { PasswordResetForm } from "./PasswordResetForm/PasswordResetForm";
import ConfirmDeleteModal from "./ConfirmDeleteModal/ConfirmDeleteModal";
import RecipeTipps from "@/components/RecipeComponents/Modals/RecipeTipps/RecipeTipps";
import { EquipmentType, RecipeType } from "@/types/baseTypes";
import { RecipeFilterModal } from "@/components/RecipeComponents/Modals/RecipeFilter/RecipeFilterModal";
import { FilterModalCloseButton } from "@/components/RecipeComponents/Modals/RecipeFilter/General/FilterModalCloseButton";
import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import BackgroundBubbles from "@/components/BackgroundBubbles/BackgroundBubbles";
import { SortedCategoriesType } from "@/utils/rezeptAPI/getRecipeFilterOptions";
import RecipeTools from "@/components/RecipeComponents/Modals/RecipeTools/RecipeTools";

export const FormModal = ({
  recipeDetails,
  equipmentList,
  filterOptions,
}: {
  filterOptions: SortedCategoriesType | null;
  recipeDetails?: RecipeType;
  equipmentList?: EquipmentType[];
}) => {
  const { formModalText, formModalType, setFormModalType } = useAppContext();
  const { setOpen } = useModal();

  if (formModalType === "recipe-filter")
    return (
      <div className="column is-10 p-0">
        <FilterModalCloseButton
          className={styles["outside-modal-close-btn"]}
          handleClick={() => {
            setOpen(false);
            setFormModalType("text");
          }}
        />

        <div className={`${styles["filter-modal"]}`}>
          <RecipeFilterModal filterOptions={filterOptions} />
          <BackgroundBubbles topLeft={false} topRight={false} />
        </div>
      </div>
    );

  return (
    <div
      className={`column is-10-tablet is-8-desktop is-8-widescreen ${styles["form-modal-wrapper"]}`}
    >
      {formModalType === "text" && (
        <p
          className={`p-5 ${styles["form-modal"]}`}
          dangerouslySetInnerHTML={{ __html: customSanitize(formModalText) }}
        ></p>
      )}
      {formModalType === "reset" && (
        <div className={`p-5 ${styles["form-modal"]}`}>
          <PasswordResetForm />
        </div>
      )}
      {formModalType === "delete" && (
        <div className={`p-5 ${styles["form-modal"]}`}>
          <ConfirmDeleteModal />
        </div>
      )}
      {formModalType === "recipe-tipp" && recipeDetails && (
        <div className={`p-5 ${styles["form-modal"]}`}>
          <RecipeTipps recipeDetails={recipeDetails} />
        </div>
      )}
      {formModalType === "recipe-tools" && equipmentList && (
        <div className={`p-5 ${styles["form-modal"]}`}>
          <RecipeTools equipmentList={equipmentList} />
        </div>
      )}
    </div>
  );
};
